interface DirectionsTarget {
  name: string;
  location: { lat: number; lon: number };
}

/** iPadOS 13+ reports a desktop Mac user agent; touch points give it away. */
const isAppleMobile = (userAgent: string, maxTouchPoints: number): boolean =>
  /iPad|iPhone|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1);

/**
 * Directions URL for the device's own navigation app: Apple Maps on iOS, the
 * Android `geo:` intent (which offers the user's chosen maps app) on Android,
 * and Google Maps in the browser everywhere else.
 */
export const getDirectionsUrl = (
  pub: DirectionsTarget,
  userAgent: string = navigator.userAgent,
  maxTouchPoints: number = navigator.maxTouchPoints ?? 0
): string => {
  const { lat, lon: lng } = pub.location;
  const name = encodeURIComponent(pub.name);
  if (isAppleMobile(userAgent, maxTouchPoints)) {
    return `maps://maps.apple.com/?daddr=${lat},${lng}&q=${name}`;
  }
  if (/Android/.test(userAgent)) {
    return `geo:${lat},${lng}?q=${lat},${lng}(${name})`;
  }
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
};

export const openDirections = (pub: DirectionsTarget): void => {
  window.open(getDirectionsUrl(pub), '_blank');
};
